if (!customElements.get("variant-selects-extended")) {
  class VariantSelectsExtended extends HTMLElement {
    constructor() {
      super();
      this.boundUpdateProductForm = this.updateProductForm.bind(this);
    }

    connectedCallback() {
      this.addEventListener("change", this.boundUpdateProductForm);
      setTimeout(() => {
        this.updateProductForm();
      }, 250);

      document
        .querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        )
        .forEach((productForm) => {
          const input = productForm.querySelector(
            'input[name="properties[Crystal SKU]"]'
          );
          input?.addEventListener("change", this.boundUpdateProductForm);
        });
    }

    disconnectedCallback() {
      this.removeEventListener("change", this.boundUpdateProductForm);
    }

    handleVariantChange(html) {
      html
        .querySelectorAll(`#${this.id} input[type="radio"]`)
        .forEach((input) => {
          const currentInput = this.querySelector(
            `#${CSS.escape(input.getAttribute("id"))}`
          );
          if (!currentInput) return;

          const newVariantImage =
            input.parentNode.querySelector("div.variant-image");
          const currentVariantImage =
            currentInput.parentNode.querySelector("div.variant-image");
          if (newVariantImage && currentVariantImage) {
            currentVariantImage.innerHTML = newVariantImage.innerHTML;
          }

          currentInput.parentNode.classList.toggle(
            "extended-hidden",
            input.parentNode.classList.contains("extended-hidden")
          );
          const isDisabled = input.hasAttribute("disabled");
          currentInput.toggleAttribute("disabled", isDisabled);
          currentInput.classList.toggle("disabled", isDisabled);
          currentInput.parentNode.classList.toggle("disabled", isDisabled);
          if (isDisabled) currentInput.checked = false;
        });

      this.updateProductForm();
    }

    updateProductForm() {
      const freeLabel = this.dataset.freeLabel || "Free";
      const freePriceHtml = `<span class="price-item price-item--regular">${freeLabel}</span>`;

      document
        .querySelectorAll(
          `.product-form ul li[data-variant-extended="${this.id}"]`
        )
        .forEach((item) => item.remove());

      this.selectedOptionValues.forEach((target) => {
        const productTitle = target.dataset.productTitle;
        const heading = target.dataset.heading;
        const parent = target.item.closest("label");
        const price = parent?.querySelector(".price");
        const priceContainer = parent?.querySelector(".price__container");
        const isNoneOption =
          this.dataset.useNoneLabel === "true" &&
          Number(target.dataset.priceCents || 0) === 0;
        const saleMessage =
          priceContainer && priceContainer.dataset.salePercentage !== "0"
            ? `<span class="percent">${priceContainer.dataset.salePercentageMessage}</span>`
            : "";
        const html = `<strong class="option-name">${heading} ${saleMessage}</strong>
          <div class="price price--on-sale">
            ${isNoneOption ? freePriceHtml : price ? price.innerHTML : freePriceHtml}
          </div>
          ${isNoneOption ? "" : `<span class="option-descr">${productTitle}</span>`}`;
        const element = document.createElement("li");
        element.dataset.variantExtended = this.id;
        element.innerHTML = html;

        document
          .querySelectorAll(".product-form ul")
          .forEach((item) => item.prepend(element.cloneNode(true)));
      });

      if (!this.form) return;
      this.form
        .querySelectorAll(`[data-variant-extended="${this.id}"]`)
        .forEach((item) => item.remove());

      this.selectedOptionValues.forEach((target, index) => {
        this.form.append(
          this.createHiddenInput(index, "[id]", target.dataset.variantId),
          this.createHiddenInput(index, "[quantity]", "1"),
          this.createHiddenInput(
            index,
            "[properties][_Group Identify]",
            document.querySelector('[name="properties[_Group Identify]"]')
              ?.value
          ),
          this.createHiddenInput(
            index,
            "[properties][Crystal SKU]",
            document.querySelector('[name="properties[Crystal SKU]"]')?.value
          )
        );
      });

      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.productFormUpdated, { data: {} });
      }
    }

    createHiddenInput(index, name, value) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.dataset.variantExtended = this.id;
      input.name = `items[${this.id}-${index}]${name}`;
      input.value = value || "";
      return input;
    }

    get selectedOptionValues() {
      return Array.from(
        this.querySelectorAll("select option[selected], fieldset input:checked")
      ).map((item) => ({
        item,
        dataset: { ...item.dataset },
      }));
    }

    get form() {
      return document.querySelector(`#${this.dataset.productFormId}`);
    }
  }

  customElements.define("variant-selects-extended", VariantSelectsExtended);
}
